module.exports = __webpack_public_path__ + "img/mail.463c49e6.svg";